import PropTypes from 'prop-types';
import React from 'react';
import { OverlayTrigger, Popover } from 'react-bootstrap';

class IconTooltip extends React.Component {
  propTypes = {
    text: PropTypes.string,
    iconElement: PropTypes.element,
    onIconClick: PropTypes.func,
    placement: PropTypes.string,
  };

  render() {
    const IconTooltipContainerStyle = {
      display: 'flex',
      alignItems: 'center',
      position: 'relative',
      marginLeft: 10,
    };
    const tooltipBodyStyle = {
      borderRadius: 25,
      backgroundColor: '#4a90e2',
      color: 'white',
      padding: '5px 0',
      textAlign: 'center',
      fontSize: 12,
    };
    const placement = this.props.placement || 'top';
    return (
      <div style={IconTooltipContainerStyle}>
        <OverlayTrigger
          placement={placement}
          overlay={
            <Popover style={tooltipBodyStyle}>{this.props.text}</Popover>
          }
        >
          <div onClick={this.props.onIconClick} style={{ cursor: 'pointer' }}>
            {this.props.iconElement}
          </div>
        </OverlayTrigger>
      </div>
    );
  }
}

export default IconTooltip;
